import { InMemoryCache } from "@apollo/client";
import { relayStylePagination } from "@apollo/client/utilities";
import result from "../introspectionQueryResult";
import { customRelayStylePagination } from "./customRelayStylePagination";

export const cache = new InMemoryCache({
  possibleTypes: result.possibleTypes,
  typePolicies: {
    ReviewSummary: {
      fields: {
        reviews: relayStylePagination(),
      },
    },
    Category: {
      fields: {
        genres: relayStylePagination(),
      },
    },
    CommonSeasonAssets: {
      merge: true,
    },
    SeasonState: {
      merge: true,
    },
    Season: {
      merge: true,
      fields: {
        staff: relayStylePagination(),
        casts: relayStylePagination(),
      },
    },
    Episode: {
      fields: {
        parts: relayStylePagination(),
      },
    },
    Viewer: {
      merge: true,
      fields: {
        videoPriceDropNotifications: relayStylePagination(),
        videoBookmarks: relayStylePagination(),
        purchasedVideos: relayStylePagination(["sort"]),
        videoPlayHistories: relayStylePagination(),
      },
    },
    VideoPriceDropNotification: {
      merge: true,
      keyFields: ["id", "priceWhenAdded", "latestPrice"],
    },
    VideoPriceSummary: {
      merge: true,
    },
    VideoSeason: {
      merge: true,
      fields: {
        reviews: relayStylePagination(),
        purchasedContents: relayStylePagination(),
      },
    },
    VideoLegacySeason: {
      merge: true,
      fields: {
        reviews: relayStylePagination(),
      },
    },
    VideoStageSeason: {
      merge: true,
      fields: {
        reviews: relayStylePagination(),
        purchasedContents: relayStylePagination(),
      },
    },
    VideoSpotLiveSeason: {
      merge: true,
    },
    VideoContent: {
      merge: true,
    },
    VideoPlayInfo: {
      merge: true,
    },
    VideoFreeProduct: {
      merge: true,
    },
    VideoPPVProduct: {
      merge: true,
    },
    VideoSVODProduct: {
      merge: true,
    },
    VideoPPVProductPrice: {
      merge: true,
    },
    VideoRankingItem: {
      merge: true,
      keyFields: ["rank", "id"],
    },
    VideoPurchasedViewingExpiration: {
      merge: true,
    },
    VideoPart: {
      merge: true,
    },
    VideoPPVExpirationType: {
      merge: true,
    },
    VideoViewingExpiration: {
      merge: true,
    },
    VideoRentalViewingExpiration: {
      merge: true,
    },
    VideoLegacyViewingExpiration: {
      merge: true,
    },
    VideoFixedViewingExpiration: {
      merge: true,
    },
    VideoPPVExpiration: {
      merge: true,
    },
    VideoViewingRights: {
      merge: true,
    },
    VideoDownloadFile: {
      merge: true,
    },
    Quality: {
      merge: true,
    },
    VideoPartOfDownloadFile: {
      merge: true,
    },
    VideoStagePerformance: {
      merge: true,
    },
    VideoSearchFacet: {
      merge: true,
    },
    FacetItem: {
      merge: true,
    },
    VideoContentTypeFacetItem: {
      merge: true,
    },
    Home: {
      fields: {
        shelves: relayStylePagination(),
      },
    },
    ShelfOfPresetVideos: {
      merge: true,
      fields: {
        presetVideos: relayStylePagination(["id"]),
      },
    },
    PlanStatus: {
      merge: true,
    },
    SecurityCodeSettings: {
      merge: true,
    },
    Wallet: {
      merge: true,
    },
    DmmPoint: {
      merge: true,
    },
    FanzaPlanStatus: {
      merge: true,
    },
    AllVideoCopyrights: {
      merge: true,
    },
    DownloadFileUrl: {
      merge: true,
    },
    RecommendedVideo: {
      merge: true,
    },
    VideoFilter: {
      merge: true,
    },
    PaymentStatus: {
      merge: true,
    },
    Query: {
      fields: {
        comments: customRelayStylePagination(["contentId"]),
        recommendation: relayStylePagination(["categoryId"]),
        searchVideos: relayStylePagination([
          "keyword",
          "sort",
          "categories",
          "genres",
          "series",
          "casts",
          "staffs",
          "title",
          "campaigns",
          "contentType",
          "viewingTypes",
        ]),
        notifications: relayStylePagination(),
        videoRankings: relayStylePagination(["category", "term", "rankingType", "genre"]),
      },
    },
  },
});
